module.exports = __webpack_public_path__ + "img/Sommerurlaub.143f0592.svg";